function nbParse(t){ var n=parseFloat(String(t||'').replace(/[^\d,\.]/g,'').replace(',','.')); return isNaN(n)?0:n; }
function nbFmt(n){ return n.toFixed(2).replace('.',',')+'€'; }
function nbFundaPrice(b){
  var el=document.querySelector('#upsell-'+b+' .extra-price');
  return el?nbParse(el.textContent):0;
}
function nbUpdateTotal(){
  var b=parseInt(_nb.active)||1;
  var total=nbParse(_nb.prices[b]);
  if(_nb.upsell[b]) total+=nbFundaPrice(b);
  var txt=nbFmt(total);
  var t=document.getElementById('btn-total'); if(t) t.textContent=txt;
  var mainPrice=document.querySelector('.price-current'); if(mainPrice) mainPrice.textContent=_nb.prices[b]||'';
  var oldPrice=document.querySelector('.price-old'); if(oldPrice) oldPrice.textContent='';
  var badge=document.querySelector('.savings-badge'); if(badge && !badge.textContent.trim()) badge.style.display='none';
}
function nbPaintCheck(b){
  var cb=document.querySelector('#check-'+b+' .upsell-checkbox');
  if(!cb) return;
  cb.classList.remove('checked');
  if(_nb.upsell[b]){
    cb.style.background='#F26522';cb.style.borderColor='#F26522';cb.style.color='white';cb.textContent='✓';
  } else {
    cb.style.background='white';cb.style.borderColor='#C9CDD3';cb.style.color='transparent';cb.textContent='✓';
  }
}
function selectBundle(card,b){
  document.querySelectorAll('.bundle-card').forEach(function(c){c.classList.remove('selected');});
  card.classList.add('selected');
  _nb.active=parseInt(b);
  var imgs={
    1:'https://cdn.shopify.com/s/files/1/1055/2134/8945/files/PRINCIPAL_1_A_S.jpg?v=1783411497',
    2:'https://cdn.shopify.com/s/files/1/1055/2134/8945/files/DOS_ALMOHADAS_PRINCIPAL.jpg?v=1783412295',
    3:'https://cdn.shopify.com/s/files/1/1055/2134/8945/files/PRINCIPAL_4.jpg?v=1783412324'
  };
  var mainImg=document.getElementById('main-product-img');
  if(mainImg && imgs[parseInt(b)]) mainImg.src=imgs[parseInt(b)];
  nbUpdateTotal();
}
function changeImage(src, thumb){
  var mainImg=document.getElementById('main-product-img');
  if(mainImg) mainImg.src=src;
  document.querySelectorAll('.thumb').forEach(function(t){t.classList.remove('active');});
  thumb.classList.add('active');
}
function toggleUpsell(b){
  b=parseInt(b);
  _nb.upsell[b]=!_nb.upsell[b];
  nbPaintCheck(b);
  if(parseInt(_nb.active)===b) nbUpdateTotal();
}

document.addEventListener('DOMContentLoaded',function(){
  var ids={
    1:{sin:54078021042513,con:54078021075281},
    2:{sin:54078094278993,con:54078094311761},
    3:{sin:54078166171985,con:54078166204753}
  };
  // Fundas DESMARCADAS por defecto: el cliente las marca si las quiere
  _nb.upsell={1:false,2:false,3:false};
  [1,2,3].forEach(nbPaintCheck);

  // Pack seleccionado al entrar (el que tenga la clase "selected" en la ficha)
  var sel=document.querySelector('.bundle-card.selected');
  var cards=Array.prototype.slice.call(document.querySelectorAll('.bundle-card'));
  _nb.active = sel ? cards.indexOf(sel)+1 : 1;
  if(_nb.active===2){
    setTimeout(function(){
      var mainImg=document.getElementById('main-product-img');
      if(mainImg) mainImg.src='https://cdn.shopify.com/s/files/1/1055/2134/8945/files/DOS_ALMOHADAS_PRINCIPAL.jpg?v=1783412295';
    },100);
  }
  nbUpdateTotal();

  var btn=document.getElementById('add-btn');
  if(btn){
    btn.addEventListener('click',function(){
      var b=parseInt(_nb.active)||1;
      var packIds=ids[b];
      if(!packIds){return;}
      var variantId=_nb.upsell[b]?packIds.con:packIds.sin;
      btn.textContent='Añadiendo...';btn.disabled=true;
      fetch('/cart/add.js',{
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body:JSON.stringify({items:[{id:variantId,quantity:1}]})
      })
      .then(function(r){return r.json();})
      .then(function(){
        btn.textContent='✓ Añadido al carrito';
        setTimeout(function(){
          btn.disabled=false;
          btn.innerHTML='🛒 Añadir al carrito — <span id="btn-total"></span>';
          nbUpdateTotal();
          var c=document.querySelector('[data-cart-toggle]')||document.querySelector('#cart-icon-bubble');
          if(c)c.click();
        },1200);
      })
      .catch(function(){btn.textContent='Error, inténtalo de nuevo';btn.disabled=false;});
    });
  }
  document.querySelectorAll('.thumb').forEach(function(t){
    t.addEventListener('click',function(){
      document.querySelectorAll('.thumb').forEach(function(x){x.classList.remove('active');});
      t.classList.add('active');
    });
  });
});
/* Deslizar fotos con el dedo (móvil y tablet) */
document.addEventListener('DOMContentLoaded',function(){
  var box=document.querySelector('.gallery .main-image');
  var thumbs=document.querySelectorAll('.thumbnails .thumb');
  if(!box||thumbs.length<2) return;

  var st=document.createElement('style');
  st.textContent='.gallery .main-image{touch-action:pan-y;user-select:none;-webkit-user-select:none;}'
    +'#main-product-img{transition:opacity .18s ease;}'
    +'.nb-dots{display:none;justify-content:center;gap:6px;margin-top:10px;}'
    +'.nb-dots span{width:7px;height:7px;border-radius:50%;background:#D5D7DB;transition:all .2s;}'
    +'.nb-dots span.on{background:#F26522;width:18px;border-radius:4px;}'
    +'@media(max-width:768px){.nb-dots{display:flex;}}';
  document.head.appendChild(st);

  // puntitos indicadores debajo de la foto (solo móvil)
  var dots=document.createElement('div'); dots.className='nb-dots';
  thumbs.forEach(function(){ dots.appendChild(document.createElement('span')); });
  box.parentNode.insertBefore(dots, box.nextSibling);

  function current(){
    for(var i=0;i<thumbs.length;i++){ if(thumbs[i].classList.contains('active')) return i; }
    return 0;
  }
  function paintDots(){
    var c=current();
    dots.querySelectorAll('span').forEach(function(d,i){ d.classList.toggle('on', i===c); });
  }
  function go(dir){
    var n=(current()+dir+thumbs.length)%thumbs.length;
    var img=document.getElementById('main-product-img');
    if(img) img.style.opacity='0.35';
    thumbs[n].click();
    setTimeout(function(){ if(img) img.style.opacity='1'; },180);
    if(thumbs[n].scrollIntoView) thumbs[n].scrollIntoView({behavior:'smooth',block:'nearest',inline:'center'});
    paintDots();
  }
  thumbs.forEach(function(t){ t.addEventListener('click', function(){ setTimeout(paintDots,0); }); });
  paintDots();

  var x0=null,y0=null;
  box.addEventListener('touchstart',function(e){ x0=e.touches[0].clientX; y0=e.touches[0].clientY; },{passive:true});
  box.addEventListener('touchend',function(e){
    if(x0===null) return;
    var dx=e.changedTouches[0].clientX-x0, dy=e.changedTouches[0].clientY-y0;
    if(Math.abs(dx)>40 && Math.abs(dx)>Math.abs(dy)*1.3){ go(dx<0?1:-1); }
    x0=y0=null;
  },{passive:true});
});